import Api from './BaseRequest';

const GetTheoryPassedSurvey = () => {
    return Api.Get('/api/survey/theory-passed')
};

const Submit = (data) => {
    return Api.Post('/api/survey/submit', data)
}

export default {
    GetTheoryPassedSurvey,
    Submit,
};
